/*
Sohel 03/23/2023 2699762545 Added Organization form
Guru Prasad 03/23/2023 2699762545 Fixed scrolling issues
Sohel 03/27/2023 2699762545 Added Organization Type and Organization Code Validation
Akhila 03/27/2023 2699762545 validation bug fixed
Guru Prasad 04/03/2023 2699762545 Fixed column spacing issues
Guru Prasad 04/11/2023 2699762545 Fixed alignments
Ravi 04/12/2023 2699762545 Added unsaved popup changes
Prakash 08/05/2023 2692790263 add theming classname.
Prakash 09/05/2023 2692790263 fixed close button issue letter-batches .
Prakash 16/05/2023 2692790263 fixed alignments issue in tab view
Ravi 06/14/2023 2692790263 rename Revone to RevOne
Ravi 06/16/2023 2692790263 rename Company to companies
*/
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {Button, FormHelperText} from '@material-ui/core';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchClientNumberDropDownData,
  fetchCompanyDropDownData,
  fetchCorporateDropDownData,
  fetchSiteDropDownData,
} from '../../../../redux/reducers/clientMangement/Organizaation';
import {Alert} from '@material-ui/lab';
import * as Yup from 'yup';
const orgTypes = [
  {label: 'Corporate', value: 'Corporate'},
  {label: 'Site', value: 'Site'},
  {label: 'Department', value: 'Service-Client'},
  {label: 'RevOne Companies', value: 'Company'},
];

const OrganizationForm = ({
  OrganizationValues,
  setOrganizationValues,
  rowData,
  isEdit,
  setIsEdit,
  setIsOpen,
  handleDirty,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [unique, setUnique] = useState(false);
  const dispatch = useDispatch();
  const {corporateAPIdata, companyAPIdata, siteAPIdata, clientNumberAPIdata} = useSelector(
    ({organization}) => organization,
  );
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.label === option) {
          label = item;
        }
      });
    return label;
  };
  const validationSchema = Yup.object().shape({
    organizationType: Yup.mixed().test('organizationType', 'Type  is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    code: Yup.mixed()
      .test('organizationType', 'Corporate Name is required', (value, ctx) => {
        if (ctx.parent.organizationType?.value === 'Corporate' && !value?.corporateName) {
          return false;
        } else {
          return true;
        }
      })
      .test('organizationType', 'Site Name is required', (value, ctx) => {
        if (ctx.parent.organizationType?.value === 'Site' && !value?.siteName) {
          return false;
        } else {
          return true;
        }
      })
      .test('organizationType', 'Client Number is required', (value, ctx) => {
        if (ctx.parent.organizationType?.value === 'Service-Client' && !value) {
          return false;
        } else {
          return true;
        }
      })
      .test('organizationType', 'RevOne Companies Name is required', (value, ctx) => {
        if (ctx.parent.organizationType?.value === 'Company' && !value?.companyName) {
          return false;
        } else {
          return true;
        }
      }),
  });
  const getOrganizationCode = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item.corporateName === option ||
          item.siteName === option ||
          item === option ||
          item.companyName === option
        ) {
          label = item;
        }
      });
    return label;
  };
  const initialState = {
    organizationType:
      isEdit && rowData?.organizationType ?
        getObject(rowData?.organizationType, orgTypes) :
        orgTypes[0],
    code:
      isEdit && rowData?.organizationCode ?
        rowData?.organizationType === 'Corporate' ?
          getOrganizationCode(rowData?.organizationCode, corporateAPIdata) :
          rowData?.organizationType === 'Site' ?
            getOrganizationCode(rowData?.organizationCode, siteAPIdata) :
            rowData?.organizationType === 'Department' ?
              getOrganizationCode(rowData?.organizationCode, clientNumberAPIdata) :
              rowData?.organizationType === 'RevOne Companies' ?
                getOrganizationCode(rowData?.organizationCode, companyAPIdata) :
                '' :
        '',
  };

  useEffect(() => {
    dispatch(fetchCompanyDropDownData());
    dispatch(fetchCorporateDropDownData());
    dispatch(fetchSiteDropDownData());
    dispatch(fetchClientNumberDropDownData());
  }, []);
  const handleSubmit = (values) => {
    const data = {
      organizationCode:
        values?.organizationType?.value === 'Corporate' && values?.code?.corporateName ?
          values?.code?.corporateName :
          values?.organizationType?.value === 'Site' && values?.code?.siteName ?
            values?.code?.siteName :
            values?.organizationType?.value === 'Service-Client' && values?.code ?
              values?.code :
              values?.organizationType?.value === 'Company' && values?.code?.companyName ?
                values?.code?.companyName :
                '',

      organizationType: values?.organizationType?.label ? values?.organizationType?.label : '',
    };
    const copyData = [...OrganizationValues?.organizationFields];

    if (!isEdit) {
      copyData.push({...data});
      const cleanArray = copyData.reduce((unique, o) => {
        if (
          !unique.some(
            (obj) =>
              obj?.organizationType === o?.organizationType &&
              obj?.organizationCode === o?.organizationCode,
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      if (copyData?.length > cleanArray?.length) {
        setUnique(true);
      } else {
        setOrganizationValues('organizationFields', copyData);
        setIsOpen(false);
      }
    } else {
      const updatedData = copyData.map((each, i) => {
        if (i === rowData?.index) {
          return {
            ...each,
            organizationCode: data?.organizationCode || '',
          };
        } else {
          return {
            ...each,
          };
        }
      });
      const cleanArrays = updatedData.reduce((unique, o) => {
        if (
          !unique.some(
            (obj) =>
              obj?.organizationType === o?.organizationType &&
              obj?.organizationCode === o?.organizationCode,
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      if (copyData?.length > cleanArrays?.length) {
        setUnique(true);
      } else {
        setOrganizationValues('organizationFields', updatedData);

        setIsEdit(false);
      }
    }
    handleDirty(true);
  };

  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialState}
        enableReinitialize
        validateOnBlur
        validationSchema={validationSchema}
      >
        {(props) => {
          const {
            values,
            handleChange,
            touched,
            errors,
            handleReset,
            handleSubmit,
            setFieldValue,
            setTouched,
          } = props;
          return (
            <>
              {unique && (
                <Alert className="mb-2" severity="error">
                  Organization Type and Organization Code already exists
                </Alert>
              )}
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="form-row standard-field-textfields new-standard-textfields col-12">
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-6 col-xl-6`}>
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="organizationType"
                      id="organizationType"
                      size="small"
                      value={values.organizationType}
                      disabled={isEdit}
                      options={orgTypes}
                      getOptionLabel={(option) => option?.label}
                      onChange={(e, value) => {
                        setFieldValue('organizationType', value || orgTypes[0]);
                        setFieldValue('code', '');
                        setTouched({...touched, code: false});
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={`${classes.labelName}`}
                            variant="outlined"
                            required
                            error={Boolean(touched.organizationType && errors.organizationType)}
                            margin="dense"
                            label="Type"
                            placeholder="Select Type"
                          />
                        </div>
                      )}
                    />
                    <FormHelperText style={{color: 'red'}}>
                      {touched.organizationType &&
                        errors?.organizationType &&
                        errors.organizationType}
                    </FormHelperText>
                  </div>
                  {values?.organizationType?.value === 'Company' ? (
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-6 col-xl-6 close-icon`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="code"
                        id="companyName"
                        size="small"
                        value={values.code}
                        freeSolo
                        options={companyAPIdata || []}
                        getOptionLabel={(option) => {
                          return option.companyName || '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('code', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={`${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              required
                              error={Boolean(touched.code && errors.code)}
                              label="RevOne Companies Name"
                              placeholder="Select RevOne Companies Name"
                            />
                          </div>
                        )}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.code && errors?.code && errors.code}
                      </FormHelperText>
                    </div>
                  ) : values?.organizationType?.value === 'Site' ? (
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-6 col-xl-6 close-icon`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="code"
                        id="siteName"
                        size="small"
                        value={values.code}
                        freeSolo
                        options={siteAPIdata || []}
                        getOptionLabel={(option) => {
                          return option.siteName || '';
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('code', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={`${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              required
                              error={Boolean(touched.code && errors.code)}
                              label="Site Name"
                              placeholder="Select Site Name"
                            />
                          </div>
                        )}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.code && errors?.code && errors.code}
                      </FormHelperText>
                    </div>
                  ) : values?.organizationType?.value === 'Corporate' ? (
                    <div className={`col-sm-6 col-xs-6 col-md-6 col-lg-6 col-xl-6 close-icon`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="code"
                        id="corporateName"
                        size="small"
                        value={values?.code}
                        options={corporateAPIdata || []}
                        getOptionLabel={(option) => {
                          return option.corporateName || '';
                        }}
                        freeSolo
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('code', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field close-icon">
                            <GuiTextField
                              {...params}
                              className={`${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              required
                              error={Boolean(touched.code && errors.code)}
                              label="Corporate Name"
                              placeholder="Select Corporate Name"
                            />
                          </div>
                        )}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.code && errors?.code && errors.code}
                      </FormHelperText>
                    </div>
                  ) : values?.organizationType?.value === 'Service-Client' ? (
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-6 col-xl-6`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="code"
                        id="clientNumber"
                        className={` ${classes.labelName}`}
                        size="small"
                        value={values.code}
                        options={clientNumberAPIdata || []}
                        getOptionLabel={(option) => {
                          return option || '';
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('code', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              variant="outlined"
                              margin="dense"
                              required
                              error={Boolean(touched.code && errors.code)}
                              label="Client Number"
                              placeholder="Enter Client Number"
                            />
                          </div>
                        )}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.code && errors?.code && errors.code}
                      </FormHelperText>
                    </div>
                  ) : null}
                </div>
                <div className=" d-flex justify-content-center mt-3 new-standard-textfields">
                  <Button
                    variant="outlined"
                    className={`mr-1 reset-btn`}
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Reset
                  </Button>
                  <Button type="submit" variant="outlined" className={`ml-1 search-btn`}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default OrganizationForm;
